import { mergeListPreferences } from '../utils/mergeListPreferences.js';
import { useMemo, useState } from 'react';
import { defaultResourceListPreferences } from '../components/ResourceList/contexts/defaultPreferences.js';
import { useMutationUpdateResourceListViewPreferences } from '../mutations/useMutationUpdateResourceListViewPreferences.js';
import { getResourceListPreferences } from '../components/ResourceList/getResourceListPreferences.js';
import { useContextAccessToken } from '../../permission/contexts/AnonShareTokenContext.js';
import { getResourcePermissionsAndDisabledActions } from '../../resource-detail/components/context/getDisabledActionsReasons.js';

const useListViewPreferences = (resource) => {
  const accessToken = useContextAccessToken();
  const { mutate: mutatePreferences } = useMutationUpdateResourceListViewPreferences();
  const savedFolderPreferences = useMemo(() => {
    const value2 = getResourceListPreferences(resource?.preferences) || defaultResourceListPreferences;
    return {
      ...value2,
      tableColumns: Array.isArray(value2.tableColumns) && value2.tableColumns.length > 0 ? value2.tableColumns : defaultResourceListPreferences.tableColumns
    };
  }, [
    resource?.preferences
  ]);
  const [localState, setLocalState] = useState(getResourceListPreferences(resource?.preferences) || defaultResourceListPreferences);
  const value = useMemo(() => {
    if (accessToken || getResourcePermissionsAndDisabledActions(resource).disabledActions.modify) {
      const savePreferences2 = (data) => {
        setLocalState((state) => {
          return mergeListPreferences(state, data);
        });
      };
      return {
        savePreferences: savePreferences2,
        preferences: localState
      };
    }
    const savePreferences = (data) => {
      if (!resource?.id) {
        return;
      }
      return mutatePreferences({
        type: "resources",
        id: resource?.id,
        data: mergeListPreferences(savedFolderPreferences, data)
      });
    };
    return {
      preferences: savedFolderPreferences,
      savePreferences
    };
  }, [
    localState,
    savedFolderPreferences,
    accessToken,
    resource,
    mutatePreferences
  ]);
  return value;
};

export { useListViewPreferences };
//# sourceMappingURL=useListViewPreferences.js.map
